const IMG_API = 'http://www.1522znsj.com';

export default{
	IMG_API
}
